@use "../../../styles/breakpoint.module.scss" as *;

.modal {
    position: fixed;
    inset: 0;
    // Above the Suite Builder walk modal (z-index 100) and the offer-details
    // modal (102), since this opens from a tile inside the walk.
    z-index: 103;
}

.dialog {
    composes: gridContainer from "../../../styles/composable/layout.module.css";
    align-items: center;
    height: 100%;
    outline: 0;
}

.overlay {
    position: absolute;
    inset: 0;
    background-color: var(--overlay-black-56);
    z-index: 0;
}

.content {
    position: relative;
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: 2fr 3fr;
    align-items: start;
    max-height: 94dvh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    z-index: 1;

    @media ($below-tablet) {
        grid-template-columns: 1fr;
    }
}

.close {
    position: absolute;
    top: var(--spacer-16);
    right: var(--spacer-16);
    width: var(--spacer-24);
    height: var(--spacer-24);
    z-index: 2;
}

.media {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    background-color: var(--off-white);
}

.mediaPicture {
    display: block;
    width: 100%;
    max-width: 480px;
}

.mediaImage {
    display: block;
    width: 100%;
    height: auto;
    object-fit: contain;
}

.details {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-16);
    padding: var(--spacer-64) var(--spacer-48);
    text-align: left;

    @media ($below-tablet) {
        padding: var(--spacer-40) var(--spacer-32);
    }
}

.sku {
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.title {
    font: var(--font-h-32);
    text-wrap: pretty;
}

.price {
    font: var(--font-h-24);
}

.addButton {
    align-self: flex-start;
    margin-block: var(--spacer-8) var(--spacer-24);
}

// Dimensions and Warranty sit side by side under Features, matching the PDP.
.panelRow {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--spacer-40);

    @media ($below-tablet) {
        grid-template-columns: 1fr;
        gap: 0;
    }
}

.panelHeading {
    border-bottom: 1px solid var(--gray-500);
    padding-bottom: var(--spacer-12);
    margin-bottom: var(--spacer-12);
    color: var(--gray-700);
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.features {
    composes: listReset from "../../../styles/composable/utility.module.css";
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: var(--spacer-16) var(--spacer-40);

    @media ($below-tablet) {
        grid-template-columns: 1fr 1fr;
    }
}

.featureItem {
    display: flex;
    gap: var(--spacer-8);
    font: var(--font-p-12);
}

.check {
    flex: 0 0 auto;
    width: var(--spacer-16);
    height: var(--spacer-12);
    fill: var(--pecan);
}

.dimensions {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);
    font: var(--font-p-14);
}

.dimensionRow {
    display: flex;
    justify-content: space-between;
    gap: var(--spacer-16);
    font: var(--font-p-12);
}

.dimensionValue {
    text-align: right;
    white-space: nowrap;
    font-weight: 300;
}

.warrantyList {
    composes: listReset from "../../../styles/composable/utility.module.css";
    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);
    font: var(--font-p-12);

    a {
        color: inherit;
    }
}

.fullDetailsLink {
    margin-top: var(--spacer-24);
    font: var(--font-text-link-14);
    text-decoration: underline;
}
